import Swiper from 'swiper/bundle';

export const homeHero = () => {
  $('.scroll-down').click(function (e) {
    e.preventDefault();
    var windowh = $(window).height();

    console.log(windowh);

    $('html,body').animate(
      {
        scrollTop: windowh,
      },
      200,
      'linear'
    );
  });
  // expand gallery on scroll
  function expandGallery() {
    var dist = $(document).scrollTop();
    // console.log(dist);
    if (dist > $(window).height() / 1.3) {
      $('.pattern-home-hero').addClass('expanded');
      $('body.home').trigger('expanded').addClass('stop');
      $('body.home').trigger('expanded').addClass('stop');
    } else {
      $('.pattern-home-hero').removeClass('expanded');
      //.find('.swiper')
      //.removeClass('lock-swipe');
      $('body').removeClass('stop').removeClass('stop-override');
    }
  }

  $(window).on('expanded', function () {
    // console.log('worked');
    setTimeout(function () {
      $('body').addClass('stop-override');
      $('.swiper').removeClass('lock-swipe');
    }, 1500);
  });

  if ($('.pattern-home-hero').length > 0) {
    $(window).scroll(expandGallery);
    expandGallery();
  }

  //hero slider
  const heroSliderEl = '.hero-slider';

  $(heroSliderEl)
    .find('.wp-block-cover')
    .addClass('swiper-slide')
    .removeClass('alignfull')
    .wrapAll('<div class="swiper"><div class="swiper-wrapper">');

  $(heroSliderEl).find('.swiper').append('<div class="swiper-pagination">');

  new Swiper(heroSliderEl + ' .swiper', {
    //loop: true,
    speed: 400,
    //spaceBetween: 4,
    // autoplay: {
    //   delay: 4000,
    //   disableOnInteraction: true,
    // },
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },
    // freeMode: {
    //   enabled: true,
    //   sticky: true,
    // },
    // mousewheel: {
    //   //forceToAxis: true,
    //   sensitivity: 100,
    //   releaseOnEdges: true,
    // },
    // mousewheelReleaseOnEdges: true,

    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
    },
  });

  // $(heroSliderEl)
  //   .addClass('swiper')
  //   .append('<div class="swiper-pagination">')
  //   .append('<div class="swiper-button-prev">')
  //   .append('<div class="swiper-button-next">')
  //   .find('.wp-block-group__inner-container')
  //   .addClass('swiper-wrapper')
  //   .find('.wp-block-cover')
  //   .addClass('swiper-slide');
};
